import React from 'react';
import PropTypes from 'prop-types';
import { Button, Modal, ModalBody } from 'reactstrap';
import moment from 'moment';
import ContractView, {NewContract} from './ContractView';
import {apiRequest, apiPost, apiDelete} from '../../utils/request';
import {toastr} from 'react-redux-toastr';
import {IsNullOrUndefined, SHORT_DATE_FORMAT} from '../../constants';
import 'react-table/react-table.css';
import ReactTable from 'react-table';

class ContractsView extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      contracts: [],
      selectedContract: null,
      locations: [],
      loading: true,
      clients: [],
      locationOnlyContracts: true,
    };

    this.handleNewContract = this.handleNewContract.bind(this);
    this.handleSaveContract = this.handleSaveContract.bind(this);
    this.handleCancelContract = this.handleCancelContract.bind(this);
    this.loadContracts = this.loadContracts.bind(this);
    this.handleSaveContract = this.handleSaveContract.bind(this);
    this.loadControl = this.loadControl.bind(this);
    this.loadLocations = this.loadLocations.bind(this);
    this.getColumns = this.getColumns.bind(this);
  }


  handleNewContract() {
    let count = this.state.contracts.reduce((a, b) => {
      return b.id < 0 ? a + 1 : a;
    }, 0);
    let newContract = NewContract((-1 - count));
    newContract.clients = this.props.clients;
    this.setState({selectedContract: newContract});
  }


  async handleSaveContract(val) {
    let {clients} = this.state;

    await apiPost(`/api/contracts/${val.id}`, {...val, clients})
      .then(x => {
        if (x.error || x.data.Message) {
          toastr.error(`Error while saving contract, error: ${x.error ? x.error : x.data.Message}`);
        } else {
          let added = false;
          let contracts = [...this.state.contracts].map(x => {
            let returnVal = x;
            if (returnVal.id == val.id) {
              added = true;
              return val;
            }
            return returnVal;
          });
          if(!added){
            contracts = [...this.state.contracts, val];
          }

          this.setState({contracts, selectedContract: null});
          this.loadControl();
        }
      });

  }

  handleCancelContract(){
    this.setState({selectedContract: null});
  }

  async loadControl(){
    await this.loadContracts();
    await this.loadLocations();
  }

  async handleContractDelete(c){
    if(confirm('Are you sure you want to delete contract?')){
      let {parentEntityId, parentEntityName} = this.props;
      await apiDelete(`/api/contracts/${parentEntityName}/${parentEntityId}/${c.id}`)
        .then(x => {
          if (x.error || x.data.Message) {
            toastr.error(`Error while deleting contract, error: ${x.error ? x.error : x.data.Message}`);
          } else {
            let contracts = this.state.contracts.filter(x => x.id != c.id);
            this.setState({contracts});
            this.loadControl();
          }
        });
    }
  }

  handleSelectContract(ev, communication) {
    ev.preventDefault();
    this.setState({selectedContract: communication});
  }

  filterContracts(e, locationOnly) {
    e.preventDefault();
    this.setState({locationOnlyContracts: locationOnly});
  }

  async loadContracts() {
    this.setState({loading: true});
    await apiRequest(`/api/contracts/clients/${this.props.clientId}`)
      .then(x => {
        if (x.error || x.data.Message) {
          toastr.error(`Error while fetching contracts, error: ${x.error ? x.error : x.data.Message}`);
          this.setState({loading: false});
        } else {
          this.setState({contracts: Array.from(x.data), loading: false});
        }
      });
  }

  async loadLocations() {
    this.setState({loading: true});
    await apiRequest(`/api/clients?clientId=${this.props.clientId}&clientName=`)
      .then(x => {
        if (x.error || x.data.Message) {
          toastr.error(`Error while fetching locations, error: ${x.error ? x.error : x.data.Message}`);
          this.setState({loading: false});
        } else {
          let client = x.data[0];
          this.setState({locations: [...client.locations], clients: [client], loading: false});
        }
      });
  }
  
  componentDidUpdate(prevProps, prevState, snapshot) {
    let { location, clientId } = this.props;
    let prevLocation = prevProps.location;
    
    if(prevLocation && location && location.id !== prevLocation.id || clientId !== prevProps.clientId){      
      this.setState({locations: []});
      this.loadControl().then(() => {});
    }
  }
  
  componentDidMount(){
    this.loadControl().then(() => {});
  }

  getColumns() {    
    let {location, isReadOnly} = this.props;
    return [
      {
        id: 'thisLocation',
        accessor: c => !IsNullOrUndefined(location) ? (<i className={`fa fa-${c.locations.findIndex(y => y.id===location.id) >= 0 ? 'check' : 'times'}`} />) : null,
        Header: 'This Location',
        show: !IsNullOrUndefined(location) && location.id > 0,
      },
      {
        id: 'startDate',
        Header: 'Start Date',
        accessor: c => (<a href="#" onClick={(e)=>this.handleSelectContract(e, c)} >{moment(c.startDate).format(SHORT_DATE_FORMAT)}</a>),
      },
      {
        accessor: 'sequenceNumber',
        Header: 'Contract Number',
      },
      {
        id: 'isActive',
        Header: 'Is Active',
        accessor: c => (<i className={`fa fa-${c.isActive ? 'check' : 'times'}`} />),
      },
      {
        id: 'createdDate',
        Header: 'Created',
        accessor: c => (moment(c.createdDate).format(SHORT_DATE_FORMAT)),
      },
      {
        accessor: 'createdBy',
        Header: 'Created By',
      },
      {
        id: 'updatedDate',
        Header: 'Updated',
        accessor: c => (c.updatedDate ? moment(c.updatedDate).format(SHORT_DATE_FORMAT) : ''),
      },
      {
        accessor: 'updatedBy',
        Header: 'Updated By',
      },
      {
        id: 'action',
        Header: '',
        accessor: c => (<Button color="danger" onClick={() => this.handleContractDelete(c)}><i className="fa fa-times" /></Button>),
        maxWidth: 60,
        show: !isReadOnly,
      }
    ];
  }

  render(){

    let contracts = this.state.locationOnlyContracts && this.props.location && this.props.location.id > 0 ?
      this.state.contracts.filter(c => c.locations.findIndex(y => y.id==this.props.location.id) >= 0) :
      this.state.contracts;

    let {isReadOnly} = this.props;

    return (
      <div style={{marginBottom: '20px'}}>
        <Modal
          style={{maxWidth: '650px'}}
          isOpen={this.state.selectedContract!=null}
        >
          <ModalBody>
            <ContractView
              contract={this.state.selectedContract == null ? {} : this.state.selectedContract}
              onCancel={this.handleCancelContract}
              onSave={this.handleSaveContract}
              isEdit={true}
              locations={this.state.locations}
              location={this.props.location}
              isReadOnly={isReadOnly}
            />
          </ModalBody>
        </Modal>

        <div className="form-group row">
          <div className={"col-12"}>
            <h6>
              {this.props.label}&nbsp;
              { !isReadOnly &&<Button color="success" onClick={this.handleNewContract}><i className="fa fa-plus" />&nbsp;&nbsp;Add contract</Button> }
            </h6>
          </div>
        </div>
        <div className="form-group row">
          <div className="col-12 col-md-12 col-xl-12">
            { this.state.locationOnlyContracts && (this.props.location && this.props.location.id > 0 && !isReadOnly) && <span>Showing this location contracts only, <a href="#" onClick={(e)=> this.filterContracts(e,false)}>show all?</a></span>}
            { !this.state.locationOnlyContracts && (this.props.location && this.props.location.id > 0 && !isReadOnly) &&<span>Showing all client contracts, <a href="#" onClick={(e)=> this.filterContracts(e,true)}>show just this location</a></span>}
            {this.state.loading ?
                <div>Loading contracts...</div>
                :
                <ReactTable
                    sortable={false}
                    filterable={false}
                    showPagination={false}
                    data={contracts}
                    columns={this.getColumns()}
                    minRows={2}
                />
            }
          </div>
        </div>
      </div>
    );
  }
}

ContractsView.propTypes = {
  locations: PropTypes.array,
  location: PropTypes.object,
  clientId: PropTypes.number.isRequired,
  label: PropTypes.string.isRequired,
  parentEntityId: PropTypes.number.isRequired,
  parentEntityName: PropTypes.string.isRequired,
  isReadOnly: PropTypes.bool.isRequired,
};

export default ContractsView;